










































import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import { db } from '@/plugins/firebase';
import { Entry } from '@/types';

@Component
export default class Collection extends Vue {
  project: any = {};
  collection: any = {};
  entries = [];

  get sortedEntries() {
    return this.entries.sort((a, b) => (a.label > b.label ? -1 : 1));
  }

  @Watch('$route')
  async bind() {
    const colId = this.$route.params.collectionId;
    const query = db.collection('entries').where('collectionId', '==', colId)
    await this.$bind('entries', query);
    console.log(query,this.entries)
    await this.$bind('collection', db.collection('collections').doc(colId));
    const projId = this.collection.projectId;
    this.$bind('project', db.collection('projects').doc(projId));
  }

  async created() {
    this.bind();
  }
}
